<div class="loader-container">
  <ngx-loading-bar [includeSpinner]="false" [color]="'#BFC9CA '" [height]="'4px'"></ngx-loading-bar>
  <!-- <mat-progress-bar mode="indeterminate" *ngIf="loaderService.isLoading | async" ></mat-progress-bar> -->
</div>
<ngx-spinner
  bdColor="rgba(51, 51, 51, 0.8)"
  size="large"
  color="transparent"
  style="height: 100%"
  type="ball-scale-multiple"
>
  <div class="loader-inner line-scale-pulse-out">
    <div></div>
    <div></div>
    <img src="../assets/images/a-log.png" alt="" />
  </div>

  <div class="loader-inner-dark line-scale-pulse-out">
    <p class="icon">
      <span class="first"></span>
      <span class="second"></span>
    </p>
    <div></div>
    <div></div>
  </div>
</ngx-spinner>

<router-outlet></router-outlet>


<ng-template #confirmTemp>
  <div mat-dialog-content>
    <p>
      Updates have taken place on the Algo solution.  Please click "OK" below to make sure you have the best Algo experience.
    </p>
  </div>
  <div class="action-panel text-right btn-wrapper">
    <div>
      <button  class="btn btn-primary m-right" color="warn" (click)="reload()">
      OK
      </button>
    </div>
  </div>
</ng-template>
